/**
 * 联盟主理人相关路由配置
 */
const merchantRoutes = [
  {
    path: '/merchant',
    name: 'Merchant',
    component: () => import('@/views/merchant/MerchantView.vue'),
    meta: {
      title: '联盟主理人',
      requireAuth: true,
      hideNav: true
    }
  },
  {
    path: '/merchant/change-card',
    name: 'ChangeCard',
    component: () => import('@/views/merchant/ChangeCardView.vue'),
    meta: {
      title: '换卡',
      requireAuth: true,
      hideNav: true
    }
  },
  {
    path: '/merchant/my-cards',
    name: 'MyCards',
    component: () => import('@/views/merchant/MyCardView.vue'),
    meta: {
      title: '我的锦鲤品牌权益卡',
      requireAuth: true,
      hideNav: true
    }
  }
]

export default merchantRoutes
